module.exports = __webpack_public_path__ + "static/img/second1.2e2a45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/second1.png
// module id = fx8P
// module chunks = 25